import { useContext } from "react";
import Start from "src/pages/Ev/Start";
import Terms from "src/pages/Ev/Terms";
import Compatibility from "src/pages/Ev/Compatibility";
import { EV_PATHS, EV_ROUTES } from "src/consts/Routes/Ev";
import FooterLinks from "src/components/Footer/FooterLinks";
import { Route, Routes, useLocation } from "react-router-dom";
import { ThemeValues } from "src/components/ThemeUsage/theme";
import { Container, Grid, Stack, useTheme } from "@mui/material";
import { ThemeContext } from "src/components/ThemeUsage/ThemeUsage";
import EvProgressBar from "src/components/ProgressBar/MicroFrontend/Ev";
import BrandItemThemeChanger from "src/components/BrandIconThemeChanger/BrandIconThemeChanger";

const EvContainer = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const themeName = useContext(ThemeContext);
  const isUserSelectEnabled = themeName !== ThemeValues.lichtblick;

  return (
    <Stack
      sx={{
        minHeight: "100vh",
        background: theme.palette.background.default,
        userSelect: isUserSelectEnabled ? undefined : "none",
      }}
    >
      <Container
        sx={{
          p: 4,
          flexGrow: 1,
          marginTop: { xs: 0, sm: 12 },
        }}
      >
        <Grid container>
          <Grid item xs={12} sm={4}>
            <Stack gap="50px">
              {EV_ROUTES.includes(pathname) && <EvProgressBar />}
            </Stack>
          </Grid>

          <Stack
            sx={{
              display: { xs: "flex", sm: "none" },
              justifyContent: "center",
              width: "100%",
            }}
          >
            <BrandItemThemeChanger />
          </Stack>

          <Grid item xs={12} sm={8} sx={{ paddingLeft: { sm: 5, md: 20 } }}>
            <Routes>
              <Route element={<Start />} path={EV_PATHS.START} />
              <Route
                element={<Compatibility />}
                path={EV_PATHS.COMPATIBILITY}
              />
              <Route element={<Terms />} path={EV_PATHS.TERMS} />
            </Routes>
          </Grid>
        </Grid>
      </Container>
      <FooterLinks />
    </Stack>
  );
};

export default EvContainer;
